import React from 'react';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { Autoplay, EffectFade, EffectFlip, Navigation, Pagination } from "swiper/modules";

import "./Banner.css";
import { rootUrl } from '../../../App';

const Banner = ({ banner }) => {
    return (
        <>
            <section className="banner py-2 py-md-2">
                {
                    banner &&
                    <Swiper
                        navigation={false}
                        loop={true}
                        autoplay={{
                            delay: 2000,
                            disableOnInteraction: true,
                        }}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                                centeredSlides: true,
                            },
                            375: {
                                slidesPerView: 1.5,
                                spaceBetween: 10,
                                centeredSlides: true,
                            },
                            768: {
                                slidesPerView: 1.5,
                                spaceBetween: 10,
                                centeredSlides: true,
                            },
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Autoplay, EffectFade, EffectFlip, Navigation, Pagination]}
                        className="banner-swiper"
                    >
                        {
                            banner?.map((item, index) =>
                                <SwiperSlide key={index} className="banner-item">
                                    <img src={rootUrl + (item?.banner_image || item?.image)} alt={item?.alt_text} className="w-100" />
                                </SwiperSlide>
                            )
                        }

                        {/* <SwiperSlide className="banner-item">
                            <img src={rootUrl + banner[0]?.image} alt={banner[0]?.alt_text} className="w-100" />
                        </SwiperSlide>
                        <SwiperSlide className="banner-item">
                            <img src={rootUrl + banner[0]?.image} alt={banner[0]?.alt_text} className="w-100" />
                        </SwiperSlide>
                        <SwiperSlide className="banner-item">
                            <img src={rootUrl + banner[0]?.image} alt={banner[0]?.alt_text} className="w-100" />
                        </SwiperSlide> */}
                    </Swiper>
                }
            </section>
        </>
    );
};

export default Banner;